import { ReactNode } from "react";
import { DETAULT_TIME_FORMAT, DEFAULT_DATA_FORMAT, } from "../constants/constant";
import { SuperFormItemProps } from "../SuperForm";
import { filterEmptyValue } from "../utils/utils";

export function getDataFormats(formItem?: SuperFormItemProps[]) {
  const dataFormats: any = {};
  formItem?.forEach?.(item => {
    const { formItemType, name, timePickerProps, datePickerProps, rangePickerProps, zoneTimeProps, zoneProps, beforeFormItemProps, afterFormItemProps, options, } = item;
    if (formItemType === 'TimePicker') {
      if (typeof name === 'string') dataFormats[name] = timePickerProps?.format || DETAULT_TIME_FORMAT;
    }
    if (formItemType === 'DatePicker') {
      if (typeof name === 'string') dataFormats[name] = datePickerProps?.format || DEFAULT_DATA_FORMAT;
    }
    if (formItemType === 'RangePicker') {
      if (typeof name === 'string') dataFormats[name] = rangePickerProps?.format || DEFAULT_DATA_FORMAT;
    }
    if (formItemType === 'TimeSlot') {
      if (Array.isArray(name)) {
        const timeSlotFormat = datePickerProps?.format || DEFAULT_DATA_FORMAT;
        name.forEach(v => {
          dataFormats[v] = timeSlotFormat;
        })
      }
    }
    if (formItemType === 'ZoneTime') {
      if (!Array.isArray(name) || !zoneTimeProps) return;
      const beforeName = zoneProps ? name[1] : name[0];
      const afterName = zoneProps ? name[2] : name[1];
      let formatObj: any = {
        beforeName,
      };
      zoneTimeProps.options?.forEach?.(item => {
        const { timeType, value, datePickerProps, rangePickerProps, } = item;
        if (timeType === 'DatePicker' && value) formatObj[value] = datePickerProps?.format || DEFAULT_DATA_FORMAT;
        if (timeType === 'RangePicker' && value) formatObj[value] = rangePickerProps?.format || DEFAULT_DATA_FORMAT;
      });
      dataFormats[afterName] = formatObj;
    }
    if (formItemType === 'SelectCustom') {
      const momentOptions = options?.filter(item =>
        ['DatePicker', 'RangePicker', 'TimePicker'].includes(
          item.afterFormItemType,
        ),
      );
      const beforeName: string = (beforeFormItemProps?.name
        ? beforeFormItemProps?.name
        : Array.isArray(name)
        ? name[0]
        : '') as string;
      const afterName: string = (afterFormItemProps?.name
        ? afterFormItemProps.name
        : Array.isArray(name)
        ? name[1]
        : '') as string;
      if (Array.isArray(momentOptions) && momentOptions.length) {
        let formatObj: any = {
          beforeName,
        };
        momentOptions.forEach(item => {
          const {
            afterFormItemType,
            value,
            datePickerProps,
            rangePickerProps,
            timePickerProps,
          } = item;
          if (afterFormItemType === 'DatePicker' && typeof value === 'string')
            formatObj[value] = datePickerProps?.format || DEFAULT_DATA_FORMAT;
          if (afterFormItemType === 'RangePicker' && typeof value === 'string')
            formatObj[value] = rangePickerProps?.format || DEFAULT_DATA_FORMAT;
          if (afterFormItemType === 'TimePicker' && typeof value === 'string')
            formatObj[value] = timePickerProps?.format || DETAULT_TIME_FORMAT;
        });
        dataFormats[afterName] = formatObj;
      }
    }
  });
  return dataFormats;
}
/**
 * 自定义禁用时显示文字
 * @param render 
 * @param disabledRender 
 * @returns 
 */
export function formatRender(
  render?: ReactNode | ((val?: any) => ReactNode),
  disabledRender?: ReactNode | ((data?: any) => ReactNode)
) {
  if (render !== undefined) {
    if (typeof render === 'function') return render;
    return filterEmptyValue(render);
  }
  if (disabledRender !== undefined) {
    if (typeof disabledRender === 'function') return disabledRender;
    return filterEmptyValue(disabledRender);
  }
}
